import React from "react";
import LegalPage from "@/pages/LegalPage";

export default function PrivacyPolicy() {
  return (
    <LegalPage title="Privacy Policy" updated="August 2026">
      <p>
        BAT Ear Research &amp; Investigations ("we," "our," "us") respects your
        privacy. This policy explains what information we collect through this
        website, how we store it, and the choices you have. This policy applies
        to visitors from the US, UK, Canada, Ghana, and anywhere else.
      </p>

      <h2>1. Information We Collect</h2>
      <p>We only collect information you voluntarily provide:</p>
      <ul>
        <li>
          <strong>Contact form submissions:</strong> your name, email address,
          phone number, the type of help you need, and your message.
        </li>
        <li>
          <strong>Lead-magnet submissions (checklist download):</strong> your
          name, email address, and the type of help you need.
        </li>
      </ul>
      <p>
        We do <strong>not</strong> collect sensitive personal data, financial
        details, government IDs, or health information through this site.
      </p>

      <h2>2. How We Use Your Information</h2>
      <ul>
        <li>To respond to your enquiry and arrange a free consultation.</li>
        <li>To send you the free pre-investment guide you requested.</li>
        <li>To follow up about services you specifically asked us about.</li>
      </ul>
      <p>We do not use your data for advertising retargeting.</p>

      <h2>3. How We Store Your Information</h2>
      <p>
        Submissions are stored in a private database (MongoDB) accessible only
        to the founder and authorised team members. Access to that database is
        password-protected.
      </p>

      <h2>4. Third Parties</h2>
      <p>
        We do <strong>not sell</strong> your data. We do not share your
        information with third parties for marketing purposes. We use these
        processors to run the site:
      </p>
      <ul>
        <li>
          <strong>Resend</strong> (via Emergent) — to send the checklist and
          notification emails.
        </li>
        <li>
          <strong>Cal.com</strong> — if you choose to book a consultation slot,
          it is handled by Cal.com under their own privacy policy.
        </li>
      </ul>

      <h2>5. Your Rights</h2>
      <p>
        You may ask us to (a) tell you what data we hold about you, (b) correct
        any inaccuracy, or (c) delete your data entirely. Email{" "}
        <a
          href="mailto:info@batearghana.com"
          className="text-navy underline decoration-gold underline-offset-4"
        >
          info@batearghana.com
        </a>{" "}
        from the address you originally used and we will action your request
        within a reasonable timeframe.
      </p>

      <h2>6. Cookies &amp; Analytics</h2>
      <p>
        We may use basic analytics (e.g., Google Analytics 4) to understand
        aggregate traffic. No personally identifying tracking is combined with
        your contact submissions.
      </p>

      <h2>7. Contact</h2>
      <p>
        Questions about this policy? Email{" "}
        <a
          href="mailto:info@batearghana.com"
          className="text-navy underline decoration-gold underline-offset-4"
        >
          info@batearghana.com
        </a>
        .
      </p>
    </LegalPage>
  );
}
